var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContainer)?_c('v-flex',{staticClass:"DevelopmentContainer",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"color":"warning","outlined":""}},[_c('b',[_vm._v("Development Only")]),_vm._t("default")],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }